/**
 * Keeping Tab inside an open drawer (review 2026-10-19, the phone menu of U-15): without it Tab walked out of «Meny»
 * into the page behind the scrim, which a sighted keyboard user cannot see and a screen reader reads as if the menu
 * were closed.
 *
 * `trapStep` is the rule, on its own so it is tested without a browser: given the drawer's focusable elements in order
 * and the one that has focus, the element Tab (or Shift+Tab) must go to — or null to let the browser move as usual.
 *   - focus outside the drawer: to its first (Shift+Tab: its last) element;
 *   - Tab on the last: round to the first; Shift+Tab on the first: round to the last.
 */
export function trapStep<T>(items: readonly T[], active: T | null, shift: boolean): T | null {
  if (!items.length) return null;
  const i = active == null ? -1 : items.indexOf(active);
  if (i < 0) return shift ? items[items.length - 1]! : items[0]!;
  if (!shift && i === items.length - 1) return items[0]!;
  if (shift && i === 0) return items[items.length - 1]!;
  return null;
}

/** The elements of `root` that take Tab, in document order (enabled, not hidden by `inert` or display:none). */
export function focusables(root: HTMLElement | null): HTMLElement[] {
  if (!root) return [];
  const sel = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
  return Array.from(root.querySelectorAll<HTMLElement>(sel)).filter((el) => el.offsetParent !== null || el.getClientRects().length > 0);
}
